module.exports = __webpack_public_path__ + "img/handwritten-before.b3526cad.png";